<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('thirds.thirdscomponents.CustomFieldsModal.add_custom_field')"
        class="customfields-modal"
        @closed="$emit('close')"
    >
        <template slot="default">
            <div class="dialog__default">
                <!-- Query search on CF in API V2 isn't available yet -->
                <!-- <el-input
                    v-model="searchKeywords"
                    class="search-input mb-4"
                    :placeholder="$t.__('thirds.thirdscomponents.CustomFieldsModal.search_custom_fields')"
                >
                    <i slot="suffix" class="el-input__icon gray-100 icon-search"></i>
                </el-input> -->

                <section>
                    <custom-fields-group
                        v-for="(group, index) in availablesGroupFields"
                        :key="group.id"
                        :group="group"
                        :currentStore="currentStore"
                        :class="{ 'mb-4': index !== availablesGroupFields.length - 1 }"
                        @fieldsUpdated="handleFieldsUpdated"
                    >
                    </custom-fields-group>
                </section>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    :data-bot="getDatabot('btn-cancel', currentStore, null, 'cf-popup')"
                    @click="$emit('close')"
                />
                <CompassButton
                    :label="$t.__('common.actions.add')"
                    type="primary"
                    :data-bot="getDatabot('btn-save', currentStore, null, 'cf-popup')"
                    class="ml-2"
                    @click="addFields"
                />
            </div>
        </template>
    </CompassDialog>
</template>
<script>
import CustomFieldsGroup from 'vcomponents/thirds/thirdscomponents/CustomFieldsGroup.vue';
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';

export default {
    components: {
        CustomFieldsGroup,
    },
    mixins: [DataBotsFormsMixins],
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        currentStore: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showModal: this.visible,
            searchKeywords: null,
            checkedGroups: {},
        };
    },
    computed: {
        availablesGroupFields() {
            return this.$store.getters[`${this.currentStore}/availablesGroupFields`];
        },
    },
    watch: {
        visible(newValue) {
            this.showModal = newValue;
        },
    },
    methods: {
        handleFieldsUpdated(group) {
            if (group && !_.isNil(group.id)) {
                this.checkedGroups[group.id] = group.fields;
            }
        },
        addFields() {
            const fields = _.flatMap(this.checkedGroups, (group) => group);
            this.$store
                .dispatch(`${this.currentStore}/addCustomFields`, fields)
                .then(() => this.$emit('close'))
                .catch((error) => console.log(error));
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.customfields-modal {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    .search-input {
        .el-input__suffix {
            right: 0;
        }
        .el-input__inner {
            padding-right: 34px;
        }
        .icon-search {
            font-size: 16px;
            padding-right: 14px;
        }
    }
}
</style>
